export function loadFromStorage(key: string, module: string): unknown {
  const info = localStorage.getItem(key);
  if (!info) {
    return null;
  }
  return JSON.parse(info)[module];
}

export function loadFromSessionStorage(key: string, module: string): unknown {
  const info = sessionStorage.getItem(key);
  if (!info) {
    return null;
  }
  return JSON.parse(info)[module];
}
// 处理url 中的code
export function handleUrl(
  urlString: string,
  paramsToRemove: Array<string>
): string {
  try {
    // 1. 分离基础 URL 和查询字符串（因为原 URL 包含 #，标准 URL 对象处理较麻烦）
    const queryIndex = urlString.indexOf("?");
    if (queryIndex === -1) return urlString; // 没有参数直接返回

    const baseUrl = urlString.substring(0, queryIndex);
    const queryString = urlString.substring(queryIndex + 1);

    // 2. 使用 URLSearchParams 解析参数
    const searchParams = new URLSearchParams(queryString);

    // 3. 循环删除指定的参数
    paramsToRemove.forEach((param) => {
      searchParams.delete(param);
    });

    // 4. 重新组装 URL
    // searchParams.toString() 会自动生成新的查询字符串
    const newQueryString = searchParams.toString();

    // 如果有剩余参数则拼接 '?'，否则只返回基础路径
    return newQueryString ? `${baseUrl}?${newQueryString}` : baseUrl;
  } catch (error) {
    console.error("URL 处理出错:", error);
    return "";
  }
}
